export const allPermissions = {
  ADMIN: "ADMIN",
  GROWER_RELATIONS_READ: "GROWER_RELATIONS_READ",
  GROWER_RELATIONS_WRITE: "GROWER_RELATIONS_WRITE",
  WINERY_READ: "WINERY_READ",
  WINERY_WRITE: "WINERY_WRITE",
  WINEGRAPEPLANNING_READ: "WINEGRAPEPLANNING_READ",
  WINEGRAPEPLANNING_WRITE: "WINEGRAPEPLANNING_WRITE",
  QUERYTOOL_READ: "QUERYTOOL_READ",
  WORKPLANNER_READ: "WORKPLANNER_READ",
  WORKPLANNER_WRITE: "WORKPLANNER_WRITE",
  SALES_ORDER_CREATE: "SALES_ORDER_CREATE",
  SALES_ORDER_MANAGE: "SALES_ORDER_MANAGE",
  MASTERDATA_READER: "MASTERDATA_READER",
  MASTERDATA_WRITER: "MASTERDATA_WRITER",
}

export const hasPermission = (usersPermissonObj, permissionChecking) => {
  if (!usersPermissonObj) {
    return false
  }

  if (!!usersPermissonObj[allPermissions.ADMIN]) {
    return true
  }

  if (Array.isArray(permissionChecking)) {
    return permissionChecking.some(
      (permission) => !!usersPermissonObj[permission]
    )
  }

  return !!usersPermissonObj[permissionChecking]
}
